import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from 'vue';
  import { useStore } from 'vuex';
  import ShowEqualizer from '@/ShowEqualizer.vue';
  import { vibrate } from '../utils/vibrate';
  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'TracksInput',
  setup(__props, { expose }) {
  expose();

  const dropbox = ref(null);
  
  const stopEvent = (event: DragEvent): void => {
    event.stopPropagation();
    event.preventDefault();
  };
  
  const dragenter = (event: DragEvent): void => {
    stopEvent(event);
  }
  
  const dragover = (event: DragEvent): void => {
    stopEvent(event);
  }
  
  function drop(event: DragEvent): void {
    stopEvent(event);
  
    const dt = event.dataTransfer;
    const files = dt.files;
  
    updateStore(files);
  }

  const store = useStore();

  const updateStore = (newTracks: Tracks): void => {
    vibrate([300]);
    store.commit('refreshTrackList', newTracks);
    store.commit('refreshTrackListInfo');
    console.log(store.getters.trackListInfo);
  };

  const input = ref < HTMLInputElement | null > ();
  const fileSelect = ref < HTMLButtonElement | null > ();

  const handleFileUpload = async ($event: Event): Promise < void > => {
    const target = $event.target as HTMLInputElement;
    if (target && target.files) {
      updateStore(target.files);
    }
  }
  
  onMounted(() => {
    dropbox.value.addEventListener("dragenter", dragenter, false);
    dropbox.value.addEventListener("dragover", dragover, false);
    dropbox.value.addEventListener("drop", drop, false);
  });

const __returned__ = { dropbox, stopEvent, dragenter, dragover, drop, store, updateStore, input, fileSelect, handleFileUpload, ShowEqualizer }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})